import template from './birthdaySelection.tpl';
import BaseStep from './../BaseStep';
import {gsap} from 'gsap';
import LifespanModel from '../../model/lifespanModel';
import ContentModel from '../../../../model/contentModel'
import AppStateModel from '../../../../model/appStateModel';
import MainController from '../../../../controller/MainController';
import StepEvent from './../StepEvent';
import EventDispatcher from '@/core/event/eventDispatcher';
import Gauge from './../../components/gauge/gauge';
import Knob from './../../components/knob/knob';
import YearInput from './../../components/yearInput/input';
import nextBtnTemplate from "@/app/components/templates/nextButton/nextButton.tpl";
import nextBtnStyle from "@/app/components/templates/nextButton/nextButton.module.scss";



class BirthdaySelection extends BaseStep {
    private common: any;
    private gauge: Gauge | null = null;
    private knob: Knob | null = null;
    private yearInput: YearInput | null = null;

    constructor(id: string, data: any) {
        super(id, data);

        this.common = ContentModel.instance.getCommonData();
        this._data.gender_style = AppStateModel.gender;
        this._data.next_button = nextBtnTemplate({data: this._data, styles: nextBtnStyle, options: {
                "next_step": this._data.steps.birthday_selection.next_step,
                "is_round": this.common.layout.rounded_buttons ?? false
            }})
        this._template = template(this._data);
    }

    finishStep(item: HTMLElement) {

        // store state for next step
        if (this.yearInput) {
            AppStateModel.birthday = this.yearInput.inputValue.toString();
        }

        if (this.knob) {
            LifespanModel.knob_rotation = this.knob.getRotation();
        }

        //let target = item.dataset.target;
        let target = item.getAttributeNode('data-target')?.value;

        let data = {
            birthday: AppStateModel.birthday,
            next_step: target,
            id: this._id
        };

        if (target) {
            EventDispatcher.dispatchEvent(new StepEvent(StepEvent.STEP_FINISHED, data));
        }
    }


    render() {
        super.render();

        if (!this._element) return;

        this.gauge = new Gauge(this.common.limits.birthyear.min_year, this.common.limits.birthyear.max_year);
        this.gauge.appendTo(this._element);
        //this.gauge.inputValue = this.common.years.min_year;

        this.knob = new Knob(this.common.limits.birthyear.min_year, this.common.limits.birthyear.max_year);
        this.knob.setOnChangeCallback((value) => this.onKnobChange(value));

        this.yearInput = new YearInput(this.common.limits.birthyear.min_year, this.common.limits.birthyear.max_year, this._data.common.year_of_birth_aria_label);
        this.yearInput.setOnChangeCallback((value) => this.onInputChange(value));
        const knobInner = this._element.querySelector('div#knob_inner') as HTMLElement;
        if (knobInner) {
            this.yearInput.appendTo(knobInner);
        }
    }

    postRender() {
        if (!this._element || !this.knob || !this.gauge) return;

        // TweenMax gives us errors when appended to elements which have: "display: none"
        this._element.style.display = 'initial';
        this.knob.appendTo(this._element);
        this._element.style.display = 'none';

        this.setAnimationElements();

        if (this.yearInput) {
            this.yearInput.inputValue = this.yearInput.resolveValue(this.common.limits.birthyear.default);
        }

        this.gauge.getElement()?.addEventListener('click', (event) => {
            this._onClick(event)
        });

        // disable sharing for this view/step
        MainController.setSharing(false);
    }

    _onClick(event: MouseEvent) {

        let pos = { //obj
            x: Math.round(event.clientX),
            y: Math.round(event.clientY)
        };
        if (this.knob) {
            this.knob.updateByMousePosition(pos.x, pos.y);
        }
    }

    setAnimationElements() {
        if (!this._element) return;

        this.animationElements = {
            knob: this.knob?.element,
            gauge: this.gauge?.element,
            needle: this.gauge?.element?.querySelectorAll('.needle'),
            gender: this.element?.querySelector('#gender_icon'),
            input: this.yearInput?.element,
            question: this.element?.querySelectorAll('.question'),
            button: this.element?.querySelectorAll('.next_step_button'),

        }
    }

    onInputChange(value: number) {

        if (this.knob) {
            this.knob.inputValue = value;
        }

        if (this.gauge) {
            this.gauge.inputValue = value;
        }
    }

    onKnobChange(value: number) {

        if (this.yearInput) {
            this.yearInput.inputValue = value;
        }

        if (this.gauge) {
            this.gauge.inputValue = value;
        }
    }

    destroy() {

        if (this.yearInput) {
            this.yearInput.destroy();
            this.yearInput = null;
        }

        if (this.gauge) {
            this.gauge.destroy();
            this.gauge = null;
        }

        if (this.knob) {
            this.knob.destroy();
            this.knob = null;
        }
        super.destroy();
    }

    getShowAnimation(): any[] {
        let animations: any[] = [];

        let a = this.animationElements;
        let birthYearSelection = [a.knob, a.gender, a.input, a.gauge, a.question].filter(Boolean);

        // birth-year selection:
        if (birthYearSelection.length > 0) {
            animations.push(gsap.from(birthYearSelection, 0.6, {autoAlpha: 0}));
        }

        // next button:
        if (a.button) {
            animations.push(gsap.from(a.button, 0.2, {autoAlpha: 0, display: 'none', right: '-100px'}));
        }

        return animations;
    }

    getHideAnimation(): any[] {
        let animations: any[] = [];

        let a = this.animationElements;
        let birthYearInner = [a.gender, a.input, a.question].filter(Boolean);

        // birth-year selection:
        if (birthYearInner.length > 0) {
            animations.push(gsap.to(birthYearInner, 0.4, {autoAlpha: 0}));
        }
        if (a.gauge) {
            animations.push(gsap.to(a.gauge, 0.6, {autoAlpha: 0}));
        }
        if (a.knob) {
            animations.push(gsap.to(a.knob, 0, {autoAlpha: 0}));
        }
        if (a.needle) {
            animations.push(gsap.to(a.needle, 0, {autoAlpha: 0}));
        }

        // next button:
        if (a.button) {
            animations.push(gsap.to(a.button, 0.3, {autoAlpha: 0, display: 'none', bottom: '-10%'}));
        }

        return animations;
    }
}

export default BirthdaySelection;
